import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'showcase-revamp',
})
export default class ShowcaseRevamp extends Vue {



    // ----------------------------------------------
    // Properties

    public get isPlayground() {
        return this.$route.query.isPlayground;
    }

    // ----------------------------------------------
    // Actions

    public onGoBack() {
        this.$router.push('/ai-playground');
    }

}
